import { render, staticRenderFns } from "./ListManufacturer.vue?vue&type=template&id=481af10a&"
import script from "./ListManufacturer.vue?vue&type=script&lang=js&"
export * from "./ListManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports